<template>
  <div class="waiting-room-page">
    <div class="main-content">
      <div class="content-column">
        <h1 class="waiting-room-title">
          <span v-if="eventTitle">
            Hej, dobrodošli u čekaonicu za <br />
            <span class="event-name">{{ eventTitle }}!</span>
          </span>
          <span v-else> Hej, dobrodošli u čekaonicu! </span>
        </h1>
        <div v-if="positionInQueue" class="queue-box">
          <div class="queue-position-wrapper">
            <transition name="fade-translate" mode="out-in">
              <div :key="positionInQueue" class="queue-position">{{ positionInQueue }}.</div>
            </transition>
          </div>
          <div class="queue-text">si u redu čekanja</div>
        </div>
        <p class="waiting-room-description">
          Znaš kako to ide - svi žele ulaznice! Trenutno te držimo u redu kako bismo izbjegli gužvu
          na stranici.
        </p>

        <div>
          <h2 class="sub-title">Još malo i na redu si!</h2>
          <p class="waiting-room-description">
            Hvala ti na strpljenju - samo ostani ovdje, ne osvježavaj stranicu i automatski te
            prebacujemo čim dođeš na red.
          </p>
        </div>

        <div class="next-in-line-box">
          <img :src="`${frontendURL}/assets/waiting-room/tickets.svg`" alt="Waiting Room" />
          Ulaznice su ti nadohvat ruke!
        </div>
      </div>
    </div>
    <div class="illustration-container">
      <img :src="`${frontendURL}/assets/waiting-room/waiting-queue.png`" alt="Waiting Room" />
      <div class="next-in-line-text">Ulaznice su ti nadohvat ruke!</div>
      <div class="background-circle" />
    </div>
  </div>
</template>

<script>
import { frontendURL } from '../../../utils'

export default {
  name: 'waiting-room',
  props: {
    eventTitle: {
      type: String,
      default: '',
    },
    positionInQueue: {
      type: Number,
      default: null,
    },
    peopleInFront: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      frontendURL,
    }
  },
  computed: {
    isNextInLine() {
      return this.peopleInFront === 0
    },
  },
}
</script>

<style scoped>
.waiting-room-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding: 12px 24px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  font-family: 'Raleway', sans-serif;
}

.background-circle {
  position: absolute;
  width: 1200px;
  height: 1200px;
  background-color: #eaf6ff;
  border-radius: 50%;
  top: 10%;
  bottom: 0;
  right: -50%;
  z-index: 0;
}

.illustration-container {
  position: relative;
  right: 0;
  min-height: 80vh;
  bottom: -10px;
  max-width: 550px;
  margin: auto 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
}

.illustration-container img {
  width: 100%;
  min-width: 550px;
  z-index: 10;
  position: relative;
  bottom: -20%;
}

.main-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: 1200px;
  position: relative;
  z-index: 2;
}

.content-column {
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 32px;
}

.waiting-room-title {
  font-family: 'Raleway', sans-serif;
  color: #333333;
  font-weight: 800;
  font-size: 36px;
  line-height: 120%;
  letter-spacing: -3%;
  text-align: center;
}

.event-name {
  color: #0277bd;
}

.queue-box {
  background-color: #0277bd;
  color: #ffffff;
  border-radius: 8px;
  text-align: center;
  padding: 32px 140px;
}

.queue-position-wrapper {
  position: relative;
  height: 3.5rem;
}

.queue-position {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1;
}

.queue-text {
  font-size: 1.1rem;
}

.sub-title {
  font-family: 'Raleway', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: #0277bd;
  margin-bottom: 2rem;
}

.waiting-room-description {
  font-size: 20px;
  line-height: 150%;
  letter-spacing: -3%;
  text-align: center;
  color: #666666;
}

.next-in-line-box {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 24px 48px;
  width: 100%;
  color: #004c8c;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -3%;
}
.next-in-line-text {
  display: none;
}

.next-icon {
  margin-right: 0.75rem;
}

/* Mobile Styles */
@media (max-width: 960px) {
  .waiting-room-page {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .waiting-room-title {
    font-weight: 800;
    font-size: 28px;
    line-height: 120%;
    letter-spacing: -3%;
    text-align: center;
  }

  .background-circle {
    width: 100vw;
    height: auto;
    aspect-ratio: 1/1;
    left: auto;
    right: auto;
    bottom: -50%;
  }
  .next-in-line-box {
    display: none;
  }
  .next-in-line-text {
    display: block;
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: -3%;
    text-align: center;
    z-index: 10;
    color: #004c8c;
    font-family: 'Raleway', sans-serif;
  }
  .illustration-container {
    width: 300px;
    top: auto;
    min-height: 300px;
    display: flex;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .illustration-container img {
    width: auto;
    min-width: unset;
    height: 100%;
    max-height: 250px;
  }
  .main-content {
    justify-content: center;
    text-align: center;
  }
  .content-column {
    align-items: center;
    max-width: 100%;
    gap: 2rem;
  }
  .title {
    font-size: 1.75rem;
  }
  .sub-title {
    margin-bottom: 2rem;
    font-weight: 700;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -3%;
    text-align: center;
  }

  .waiting-room-description {
    font-size: 16px;
  }

  .queue-box {
    width: 200px;
    padding: 1rem;
  }
  .queue-position {
    font-size: 3rem;
  }
}

.fade-translate-enter-active,
.fade-translate-leave-active {
  transition: all 0.5s ease;
}
.fade-translate-enter,
.fade-translate-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.fade-translate-leave-active {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
}
</style>
